module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/athor30-e41d561ea48682c64e9de7ef9293b005.jpg";